// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderOuterOutlinedSvg from "@ant-design/icons-svg/es/asn/BorderOuterOutlined";
import AntdIcon from '../components/AntdIcon';

var BorderOuterOutlined = function BorderOuterOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderOuterOutlinedSvg
  }));
};

BorderOuterOutlined.displayName = 'BorderOuterOutlined';
export default React.forwardRef(BorderOuterOutlined);